import { render } from "./PublishArticle.vue?vue&type=template&id=40326167"
import script from "./PublishArticle.vue?vue&type=script&lang=js"
export * from "./PublishArticle.vue?vue&type=script&lang=js"

import "./PublishArticle.vue?vue&type=style&index=0&id=40326167&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__